module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    class: {
      bg: true, fixed: _vm.phase != 'playing'
    }
  }, [(_vm.phase === 'welcome') ? _c('dashboard', {
    attrs: {
      "start": _vm.newGame,
      "games": _vm.games,
      "startGame": _vm.loadGame
    }
  }) : (_vm.phase === 'setup') ? _c('setup', {
    attrs: {
      "cancel": _vm.cancel,
      "start": _vm.startGame
    }
  }) : _c('game', {
    attrs: {
      "close": _vm.cancel
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53c68d53"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 199
// module chunks = 0